// Polyfill Array.prototype.at for browsers that predate ES2022 (Safari < 15.4,
// Chrome < 92). PostHog loads web-vitals at runtime, and its CLS handler calls
// `this.o.at(-1)` — without this shim the entire PostHog session crashes on
// older browsers.
if (typeof Array.prototype.at !== "function") {
  Object.defineProperty(Array.prototype, "at", {
    value: function at(n: number) {
      const len = this.length >>> 0;
      let i = Math.trunc(n) || 0;
      if (i < 0) i += len;
      if (i < 0 || i >= len) return undefined;
      return this[i];
    },
    writable: true,
    configurable: true,
  });
}
